import io from 'socket.io-client'
import _ from 'lodash'
const wsAddress = process.env.WEBSOCKET_HOST

// websocket interface
interface Websocket {
  on: Function,
  emit: Function,
  broadcast: Function,
  disconnect: Function,
  connected: boolean
}

// Channel class manages web socket connections to notification channels
export default class Channel {
  callbacks: Array<(event: any) => void> = []
  currentChannel = {
    channel: "",
    channelId: ""
  }
  ws: Websocket = {
    on: () => {},
    emit: () => {},
    broadcast: () => {},
    disconnect: () => {},
    connected: false
  }

  // connect the socket
  public connect = () => {
    console.log('Attempting to connect to socket server')
    this.ws = io(wsAddress, {
      reconnection: true,
      forceNew: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity
    })

    this.ws.on('connect', () => {
      console.log('Connected to socket server')
      let event = new Event('rdcf_socket_connected')
      document.dispatchEvent(event)
    })

    this.ws.on('connect_error', data => {
      console.log(`Unable to connect to socket server ${data}`)
      let event = new Event('rdcf_socket_disconnected')
      document.dispatchEvent(event)
    })

    this.ws.on('error', data => {
      console.log('Socket error', data)
    })

    this.ws.on('disconnect', msg => {
      // Only dispatch the socket disconnect event if
      // we lose connection to the server, not when
      // we are forcefully disconnecting a socket.
      // In the future if we manage socket connections
      // separately from channel connections server-side
      // can change this flimsy logic (i.e. multiple channels one socket)
      if(msg !== 'io client disconnect') {
        console.log('Socket disconnected, attempting reconnect')
        let event = new Event('rdcf_socket_disconnected')
        document.dispatchEvent(event)
      }
    })

    this.ws.on('reconnect', attemptNum => {
      console.log('Socket reconnection successful')
      // if this socket was connected to a channel, reconnect to the same channel
      if(this.currentChannel) {
        if(!this.currentChannel.channelId) {
          this.ws.emit('channel-join', {channel: this.currentChannel.channel})
          console.log(`Rejoined channel /${this.currentChannel.channel}`)
        } else {
          this.ws.emit('channel-join', {channel: this.currentChannel.channel, channelId: this.currentChannel.channelId})
          console.log(`Rejoined channel /${this.currentChannel.channel}/${this.currentChannel.channelId}`)
        }
      }
    })
  }

  // join a channel
  public join = (channel, channelId="") => {
    // leave any channel if currently connected
    this.leave()

    // if not connected, connect to socket server and set up socket handlers
    if(!this.ws || !this.ws.connected) {
      this.connect()
    }

    // Only allow a Channel to connect to one logical channel at a time.
    // This forces clients of the class to either explicitly declare
    // multiple Channel instances in order to connect to multiple channels
    // or first leave the current channel and then join another channel.
    if(!this.currentChannel.channel) {
      this.ws.emit('channel-join', {channel, channelId})
      this.ws.on('broadcast', data => {
        this.callbacks.map((callback: (event: any) => void) => { if(callback && _.isFunction(callback)) callback(data) })
      })
      this.currentChannel = {channel, channelId}
    } else {
      console.warn(`Warning: Can only join one channel at a time.  Current channel /${this.currentChannel.channel}/${this.currentChannel.channelId}`)
    }
  }

  // set callback to handle channel events
  public onEvent = (callback: (event: any) => void) => {
    this.callbacks.push(callback)
  }

  public offEvent = (callback: (event: any) => void) => {
    _.remove(this.callbacks, cb => cb === callback)
  }

  // leave the current channel
  public leave = () => {
    if(this.ws) this.ws.disconnect()
    this.currentChannel = {
      channel: "",
      channelId: ""
    }
    this.callbacks = []
  }
}